<template>
    <div class="">

        <section :class="classes" class="page-title-area" :style="'background-image:url(' + background + ')'">
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="page-title-wrapper text-center">

                            <div v-if="title" class="page-title-box">
                                <h1 class="page-title">
                                    {{ title }}
                                </h1>
                                <ul class="breadcrumb-list">
                                    <li>
                                        <router-link :to="'/'">
                                            {{ $t('header.home') }} &nbsp;
                                            <i
                                                :class="[locale == 'ar' ? 'far fa-chevron-left' : 'far fa-chevron-right']">
                                            </i>
                                        </router-link>
                                    </li>
                                    <li>
                                        <router-link v-if="redirectTo" :to="redirectTo">
                                            {{ subtitle }}
                                        </router-link>
                                        <router-link v-if="!redirectTo && redirectTo2" :to="redirectTo2">
                                            {{ subtitle }}
                                        </router-link>
                                        <a v-if="!redirectTo && !redirectTo2" href="javascript:;">
                                            {{ subtitle }}
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <!-- webkit animation -->
                            <div v-if="!title" class="page-title-box row col-12">
                                <div class="col-4"></div>
                                <div class="page-title webkit-animation col-4 webkit-none-80"></div>
                                <div class="row col-12" :style="($i18n.locale == 'ar') ? 'left: -14px' : 'left:14px'">
                                    <div class="col-4"></div>
                                    <div class="col-2 pd-5">
                                        <div class="webkit-animation webkit-100per-50"
                                            :class="($i18n.locale == 'en') ? 'float-right' : 'float-left'">
                                        </div>
                                    </div>
                                    <div class="col-2 pd-5">
                                        <div class="webkit-animation webkit-100per-50 pull-left"></div>
                                    </div>
                                </div>
                            </div>
                            <!-- End webkit animation -->

                        </div>
                    </div>
                </div>
            </div>
        </section>

    </div>
</template>

<script>
export default {
    name: 'Banner',
    props: [
        'background',
        'title',
        'subtitle',
        'redirectTo',
        'redirectTo2',
        'classes'
    ],
    components: {},
    data() {
        return {
            locale: this.$i18n.locale
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
